import React, { useContext } from 'react'

import { PACKAGE_RECEIVED, PACKAGE_STORED, PACKAGE_STATUSES_NAMES } from '../../constants/packageStatus'
import { DataContext } from '../../context/DataContext'
import { formatDate, getHour, parseDate } from '../../utils/dates'

const UpdateComponent: React.FC = () => {
  const { sale } = useContext(DataContext)
  let lastUpdate = sale?.packageHistory?.find((history: PackageHistory) => history.packageStatus === sale?.packageStatus)

  if (!lastUpdate && sale.packageStatus === PACKAGE_STORED) {
    lastUpdate = sale?.packageHistory?.find(
      (history: PackageHistory) => history.packageStatus === PACKAGE_RECEIVED
    )
  }

  const parsedDate = lastUpdate ? parseDate(lastUpdate.date, 1) : null
  const formattedDate = parsedDate ? formatDate(parsedDate) : null
  return (
    <div className="flex items-center gap-4">
      <div className="relative flex items-center justify-center mt-0.5">
        <span className="absolute inline-flex h-4 w-4 rounded-full bg-green opacity-75 animate-ping" />
        <span className="relative inline-flex h-3 w-3 rounded-full bg-green" />
      </div>

      <div className="flex flex-col">
        <p className="text-base font-[Geist] landscape:hidden">{PACKAGE_STATUSES_NAMES[sale.packageStatus as keyof typeof PACKAGE_STATUSES_NAMES]}</p>
        <p className="text-sm text-gray-500 font-[Geist]">{formattedDate}, {parsedDate ? getHour(parsedDate) : ''} hrs.</p>
      </div>
    </div>
  )
}

export default UpdateComponent
